import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { formatCurrency } from "../utils/accountsHelpers";

const AccountsDashboard = ({
  accounts = [],
  invoices = [],
  bills = [],
  journals = [],
}) => {
  const totalReceivables = invoices.reduce(
    (sum, inv) => sum + Number(inv.totals?.outstandingAmount || 0),
    0,
  );

  const totalPayables = bills.reduce(
    (sum, bill) => sum + Number(bill.totals?.outstandingAmount || 0),
    0,
  );

  const totalIncomeAccounts = accounts.filter(
    (a) => a.mainType === "income",
  ).length;
  const totalExpenseAccounts = accounts.filter(
    (a) => a.mainType === "expense",
  ).length;

  const stats = [
    {
      label: "Outstanding Receivables",
      value: formatCurrency(totalReceivables),
    },
    { label: "Outstanding Payables", value: formatCurrency(totalPayables) },
    { label: "Journal Entries", value: journals.length },
    { label: "Income Accounts", value: totalIncomeAccounts },
    { label: "Expense Accounts", value: totalExpenseAccounts },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat) => (
        <Grid item xs={12} sm={6} md={4} lg={2.4} key={stat.label}>
          <Card>
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                {stat.label}
              </Typography>
              <Typography variant="h6" sx={{ mt: 1 }}>
                {stat.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AccountsDashboard;
